import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectors as apiSelectors } from 'zender-api-client';

import QuizToWin from './QuizToWin.component';
import * as appSelectors from '../../../../../selectors';

const QuizToWinContainer = props => <QuizToWin {...props} />;

const mapStateToProps = state => ({
	priceToWin: apiSelectors.quiz.quizPriceSelector(state),
	quizConfig: apiSelectors.target.quizConfigSelector(state),
	locale: appSelectors.locale.localeSelector(state),
});

const mapDispatchToProps = () => ({});

QuizToWinContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(QuizToWinContainer);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/quizToWin/QuizToWin.container.js